import { Options } from "@sentry/core";
import { ZodError } from "zod";

export const beforeSend: NonNullable<Options["beforeSend"]> = (event, hint) => {
    const exception = hint.originalException;
    const eventCopy = { ...event };
    if (exception instanceof ZodError) {
        eventCopy.fingerprint = ["{{ default }}", exception.issues[0].path.join("-")];
    }
    return eventCopy;
};
